<!-- La cuenta es creada normalmente  -->
<div *ngIf="createFromEmail == null && createFromPhone == null">
    <div class="header">
        <div class="header-background">
            <div class="d-flex justify-content-between">
                <!-- Logo -->
                <div style="position: relative; z-index: 0;">
                    <img src="assets/images/register/Banner_Registro_2_Datos.png" style="width: 100%;">
                </div>
            </div>
        </div>
    </div>

    <div id="allContent" class="background-default">
        <section id="wrapper">
            <div class="register">

                <div class="register-box" style="position: relative; z-index: 100;">

                    <app-register-new-form (onSave)="onSave($event)" (checkEmail)="onCheckEmail($event)" (checkPhone)="onCheckPhone($event)"
                        (verifyEmail)="onVerifyEmail($event)" (verifyPhone)="onVerifyPhone($event)" (onCancel)="onCancel()" [inviteCode]="inviteCode"
                        [isVerificationSuccess]="isVerificationSuccess" [emailDuplicated]="emailDuplicated" [customerPhoneDuplicated]="customerPhoneDuplicated"
                        [isVerificationWithPhone]="false" [receivedCountry]="country" [requestName]="requestName">
                    </app-register-new-form>
                </div>
            </div>
        </section>
    </div>
</div>


<!-- La cuenta es creada desde el modal de recibir un Givi o Checkout -->
<div *ngIf="createFromEmail?.length || createFromPhone">
    <app-register-new-form (onSave)="onSave($event)" (checkEmail)="onCheckEmail($event)" (checkPhone)="onCheckPhone($event)"
        (verifyEmail)="onVerifyEmail($event)" (verifyPhone)="onVerifyPhone($event)" (onCancel)="onCancel()" [inviteCode]="inviteCode"
        [isVerificationSuccess]="isVerificationSuccess" [emailDuplicated]="emailDuplicated" [customerPhoneDuplicated]="customerPhoneDuplicated"
        [emailReceived]="createFromEmail" [phoneReceived]="createFromPhone" [receivedCountry]="country" [customerWithoutRegister]="customerWithoutRegister"
        [isVerificationWithPhone]="false" [requestName]="requestName">
    </app-register-new-form>
</div>